module.exports = __webpack_public_path__ + "static/img/pic_temp.9c781fe9.png";